import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../store/store";
import { ROUTES } from "../utils/constants";

interface FlowStepGuardProps {
  children: React.ReactNode;
}

export const FlowStepGuard = ({ children }: FlowStepGuardProps) => {
  const visitId = useSelector((state: RootState) => state.visitor.visitStatus.visitId);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  if (visitId) {
    return <Navigate to={`/${ROUTES.CONFIRMATION}`} replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
